/* Fichier Shopify : assets/rs-installments.js  (Modifier le code > Assets). Ne rien modifier ici : les réglages sont dans snippets/rs-installments.liquid */
/* ============================================================
   Radiance Systems : paiement en plusieurs fois
   Sélecteur 2× / 3× / 4× + prêteurs éligibles selon le montant
   (Sofinco / PayPal / Klarna, configurés dans snippets/rs-installments.liquid)

   API :
     RSInstallments.update(totalEuros, group?)  met à jour les widgets (d'un groupe ou tous)
     RSInstallments.scan()                      initialise les widgets ajoutés dynamiquement
   Ou plus simple : poser l'attribut data-amount (en centimes) sur [data-rs-inst],
   le widget se met à jour tout seul (MutationObserver).
   ============================================================ */
(function () {
  'use strict';
  if (window.RSInstallments) { window.RSInstallments.scan(); return; }

  var STORE_KEY = 'rs_inst_n';
  var state = { n: null, userPicked: false };
  try {
    var saved = parseInt(localStorage.getItem(STORE_KEY), 10);
    if (saved) { state.n = saved; state.userPicked = true; }
  } catch (e) {}

  /* ---------- Utils ---------- */
  var fmtCache = {};
  function fmt(cents, cfg) {
    var loc = cfg.locale || 'fr-FR', cur = cfg.currency || 'EUR', k = loc + cur;
    if (!fmtCache[k]) {
      try { fmtCache[k] = new Intl.NumberFormat(loc, { style: 'currency', currency: cur }); }
      catch (e) { fmtCache[k] = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }); }
    }
    return fmtCache[k].format(cents / 100);
  }
  /* Plafonds et seuils : "3 000 €" plutôt que "3 000,00 €" */
  function fmtShort(cents, cfg) {
    var loc = cfg.locale || 'fr-FR', cur = cfg.currency || 'EUR';
    try { return new Intl.NumberFormat(loc, { style: 'currency', currency: cur, maximumFractionDigits: 0 }).format(cents / 100); }
    catch (e) { return fmt(cents, cfg); }
  }
  function tpl(str, amount) { return String(str || '').replace('{amount}', amount); }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function cfgOf(node) {
    if (node.__rsCfg) return node.__rsCfg;
    var cfg = {};
    try { cfg = JSON.parse(node.getAttribute('data-config') || '{}'); } catch (e) {}
    cfg.counts = cfg.counts || [2, 3, 4];
    cfg.lenders = cfg.lenders || [];
    cfg.text = cfg.text || {};
    cfg.maxAll = cfg.lenders.reduce(function (m, l) { return Math.max(m, l.max || 0); }, 0);
    node.__rsCfg = cfg;
    return cfg;
  }
  function amountOf(node) { return parseInt(node.getAttribute('data-amount') || '0', 10) || 0; }

  function eligible(l, n, eur) {
    return l.counts.indexOf(n) !== -1 && eur >= (l.min || 0) && eur <= (l.max || Infinity);
  }
  function lendersFor(cfg, n, eur) {
    return cfg.lenders.filter(function (l) { return eligible(l, n, eur); });
  }
  /* Nombre d'échéances affiché :
     choix du client s'il en a fait un, sinon 3× si possible, sinon le max disponible */
  function pickN(cfg, eur) {
    if (state.userPicked && state.n && cfg.counts.indexOf(state.n) !== -1) return state.n;
    var pref = cfg.defaultCount || 3;
    if (lendersFor(cfg, pref, eur).length) return pref;
    var avail = cfg.counts.filter(function (n) { return lendersFor(cfg, n, eur).length; });
    return avail.length ? Math.max.apply(null, avail) : pref;
  }
  function split(cents, n) {
    var each = Math.floor(cents / n);
    return { each: each, first: cents - each * (n - 1) };
  }

  /* ---------- Widget complet ---------- */
  function buildFull(node) {
    var cfg = cfgOf(node), t = cfg.text;
    node.innerHTML = '';

    var head = el('div', 'rs-inst__head');
    head.appendChild(el('span', 'rs-inst__title', t.title || 'Payer en plusieurs fois'));
    var seg = el('div', 'rs-inst__seg');
    seg.setAttribute('role', 'radiogroup');
    seg.setAttribute('aria-label', t.segLabel || "Nombre d'échéances");
    cfg.counts.forEach(function (n) {
      var b = el('button', null, n + '×');
      b.type = 'button';
      b.setAttribute('role', 'radio');
      b.setAttribute('data-n', n);
      b.addEventListener('click', function () { choose(n); });
      seg.appendChild(b);
    });
    head.appendChild(seg);

    var main = el('div', 'rs-inst__main');
    main.appendChild(el('span', 'rs-inst__each'));
    main.appendChild(el('span', 'rs-inst__free', t.feeFree || 'sans frais'));
    main.appendChild(el('span', 'rs-inst__first'));

    var list = el('ul', 'rs-inst__lenders');
    var empty = el('p', 'rs-inst__empty');
    empty.hidden = true;

    node.appendChild(head);
    node.appendChild(main);
    node.appendChild(list);
    node.appendChild(empty);
  }

  function renderFull(node) {
    var cfg = cfgOf(node), t = cfg.text;
    var cents = amountOf(node), eur = cents / 100;
    node.hidden = cents <= 0;
    if (cents <= 0) return;

    var n = pickN(cfg, eur);
    var ok = lendersFor(cfg, n, eur);

    node.querySelectorAll('.rs-inst__seg button').forEach(function (b) {
      var bn = parseInt(b.getAttribute('data-n'), 10);
      b.setAttribute('aria-checked', bn === n ? 'true' : 'false');
      b.classList.toggle('is-off', !lendersFor(cfg, bn, eur).length);
    });

    var eachEl = node.querySelector('.rs-inst__each');
    var firstEl = node.querySelector('.rs-inst__first');
    var freeEl = node.querySelector('.rs-inst__free');
    /* "sans frais" affiché une seule fois, à côté du montant, si tous les prêteurs éligibles le sont */
    var allFree = ok.length > 0 && ok.every(function (l) { return l.feeFree; });
    freeEl.hidden = !allFree;
    var list = node.querySelector('.rs-inst__lenders');
    var empty = node.querySelector('.rs-inst__empty');
    list.innerHTML = '';

    if (!ok.length) {
      node.classList.add('is-unavailable');
      eachEl.textContent = n + ' × ' + fmt(split(cents, n).each, cfg);
      firstEl.textContent = '';
      empty.hidden = false;
      empty.innerHTML = '';
      var anyCount = cfg.counts.some(function (c) { return lendersFor(cfg, c, eur).length; });
      empty.appendChild(document.createTextNode(
        anyCount ? (t.noneForCount || 'Non disponible pour ce nombre d’échéances.')
                 : tpl(t.none, fmtShort(cfg.maxAll * 100, cfg)) + ' '
      ));
      if (!anyCount && t.contactUrl) {
        var a = el('a', null, t.contactLabel || 'Nous contacter');
        a.href = t.contactUrl;
        empty.appendChild(a);
      }
    } else {
      node.classList.remove('is-unavailable');
      empty.hidden = true;
      var s = split(cents, n);
      eachEl.textContent = n + ' × ' + fmt(s.each, cfg);
      firstEl.textContent = s.first !== s.each ? tpl(t.first, fmt(s.first, cfg)) : '';
    }

    /* Prêteurs proposant ce nombre d'échéances : éligibles en premier, puis hors plafond (grisés) */
    cfg.lenders
      .filter(function (l) { return l.counts.indexOf(n) !== -1; })
      .sort(function (a, b) { return eligible(b, n, eur) - eligible(a, n, eur); })
      .forEach(function (l) {
        var isOk = eligible(l, n, eur);
        var li = el('li', 'rs-inst__lender ' + (isOk ? 'is-ok' : 'is-off'));
        var img = el('img');
        img.src = l.logo; img.alt = l.name; img.loading = 'lazy';
        img.width = 72; img.height = 20;
        li.appendChild(img);
        var note = '';
        if (isOk) note = l.note || (l.feeFree && !allFree ? (t.feeFree || 'sans frais') : '');
        else if (eur < (l.min || 0)) note = tpl(t.from, fmtShort(l.min * 100, cfg));
        else note = tpl(t.upTo, fmtShort(l.max * 100, cfg));
        if (note) li.appendChild(el('span', 'rs-inst__lnote', note));
        li.title = l.name;
        list.appendChild(li);
      });
  }

  /* ---------- Version compacte (footer sticky) ---------- */
  function buildMini(node) {
    node.innerHTML = '';
    var b = el('button', 'rs-inst-mini');
    b.type = 'button';
    b.appendChild(el('span', 'rs-inst-mini__txt'));
    b.appendChild(el('span', 'rs-inst-mini__logos'));
    b.addEventListener('click', function () {
      var group = node.getAttribute('data-group');
      var target = document.querySelector('[data-rs-inst][data-variant="full"][data-group="' + group + '"]');
      if (!target) return;
      var det = target.closest('details');
      if (det) det.open = true;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      target.classList.remove('is-flash'); void target.offsetWidth; target.classList.add('is-flash');
    });
    node.appendChild(b);
  }

  function renderMini(node) {
    var cfg = cfgOf(node), t = cfg.text;
    var cents = amountOf(node), eur = cents / 100;
    var n = pickN(cfg, eur);
    var ok = lendersFor(cfg, n, eur);
    if (!ok.length) {
      /* le choix du client n'est pas possible : on montre la meilleure option dispo */
      var avail = cfg.counts.filter(function (c) { return lendersFor(cfg, c, eur).length; });
      if (avail.length) { n = Math.max.apply(null, avail); ok = lendersFor(cfg, n, eur); }
    }
    node.hidden = cents <= 0 || !ok.length;
    if (node.hidden) return;

    var txt = node.querySelector('.rs-inst-mini__txt');
    txt.innerHTML = '';
    txt.appendChild(document.createTextNode((t.miniPrefix || 'ou') + ' '));
    txt.appendChild(el('strong', null, n + '× ' + fmt(split(cents, n).each, cfg)));
    if (ok.every(function (l) { return l.feeFree; })) {
      txt.appendChild(document.createTextNode(' ' + (t.feeFree || 'sans frais')));
    }

    var logos = node.querySelector('.rs-inst-mini__logos');
    logos.innerHTML = '';
    ok.forEach(function (l) {
      var img = el('img');
      img.src = l.logo; img.alt = l.name; img.loading = 'lazy';
      img.width = 48; img.height = 14;
      logos.appendChild(img);
    });
  }

  /* ---------- Orchestration ---------- */
  function render(node) {
    if (node.getAttribute('data-variant') === 'mini') renderMini(node);
    else renderFull(node);
  }
  function renderAll() {
    document.querySelectorAll('[data-rs-inst][data-ready]').forEach(render);
  }
  function choose(n) {
    state.n = n; state.userPicked = true;
    try { localStorage.setItem(STORE_KEY, String(n)); } catch (e) {}
    renderAll();
  }

  var observer = ('MutationObserver' in window) ? new MutationObserver(function (muts) {
    muts.forEach(function (m) { render(m.target); });
  }) : null;

  function scan() {
    document.querySelectorAll('[data-rs-inst]:not([data-ready])').forEach(function (node) {
      node.setAttribute('data-ready', '');
      if (node.getAttribute('data-variant') === 'mini') buildMini(node);
      else buildFull(node);
      if (observer) observer.observe(node, { attributes: true, attributeFilter: ['data-amount'] });
      render(node);
    });
  }

  function update(totalEuros, group) {
    var cents = Math.round((Number(totalEuros) || 0) * 100);
    var sel = '[data-rs-inst]' + (group ? '[data-group="' + group + '"]' : '');
    document.querySelectorAll(sel).forEach(function (node) {
      node.setAttribute('data-amount', cents);
      if (!observer) render(node);
    });
  }

  window.RSInstallments = { update: update, scan: scan, render: renderAll };

  scan();
  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);

  /* Page produit Dawn : suit le changement de variante */
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
        var d = evt && evt.data;
        if (!d || !d.variant) return;
        document.querySelectorAll('[data-rs-inst][data-group="' + d.sectionId + '"]').forEach(function (node) {
          node.setAttribute('data-amount', d.variant.price);
        });
      });
    }
  } catch (e) {}
})();
